import { useEffect, useState } from 'react';
import { ArrowLeft, FileSignature, Loader2 } from 'lucide-react';
import { Link } from 'react-router';
import logo from '@/assets/599ad72d49c8887573a4750887df95ce60e36150.png';
import { settingsService } from '../services/settingsService';

const CONTRACT_KEY = 'driver_registration_contract';
const DEFAULT_CONTRACT_MESSAGE = 'Kayıt sözleşmesi henüz tanımlanmamış. Lütfen yönetim panelinden sözleşme metnini güncelleyin.';

export function RegistrationAgreement() {
  const [contract, setContract] = useState(DEFAULT_CONTRACT_MESSAGE);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    settingsService
      .getPublicSettingValue<string>(CONTRACT_KEY, DEFAULT_CONTRACT_MESSAGE)
      .then((value) => {
        if (!active) return;
        setContract(String(value || DEFAULT_CONTRACT_MESSAGE));
      })
      .catch(() => {
        if (!active) return;
        setContract(DEFAULT_CONTRACT_MESSAGE);
      })
      .finally(() => {
        if (!active) return;
        setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-10">
      <div className="mx-auto max-w-5xl space-y-8 rounded-3xl border border-slate-200 bg-white p-8 shadow-sm md:p-10">
        <div className="flex items-center justify-between gap-4">
          <Link to="/driver-mobile-auth" className="inline-flex items-center gap-2 rounded-full bg-slate-100 px-4 py-2 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-200">
            <ArrowLeft className="h-4 w-4" /> Geri Dön
          </Link>
          <img src={logo} alt="Yük Ortağım Logo" className="h-14 w-auto rounded-2xl border border-slate-200 bg-white p-2 shadow-sm" />
        </div>

        <div>
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-sm font-medium text-amber-800">
            <FileSignature className="h-4 w-4" /> Dış Sürücü Kayıt Süreci
          </div>
          <h1 className="text-3xl font-bold text-slate-900">Yük Ortağım Yurt İçi Taşımacılık Hizmet Sözleşmesi</h1>
        </div>

        <section className="space-y-5 leading-7 text-slate-700">
          {loading ? (
            <div className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-slate-50 p-5 text-slate-600">
              <Loader2 className="h-5 w-5 animate-spin" /> Sözleşme yükleniyor...
            </div>
          ) : (
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-6 text-sm leading-7 text-slate-700 whitespace-pre-wrap">
              {contract}
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
